module.exports = __webpack_public_path__ + "images/erp-nation-glad-top-2026-2027.1791972770245.jpg";